module.exports = __webpack_public_path__ + "static/media/dowload.2f83459d.svg";